import { FC, useContext } from "react";
import { TabsContext } from "../contexts/tabsContext";
import { TabKey } from "../constants/tabs";
import { TabContentLayout } from "./TabContentLayout";

export const TabPanel: FC<{ value: TabKey, fullscreen: boolean }> = ({ children, value, fullscreen }) => {
  const [field] = useContext(TabsContext);
  if (field !== value) {
    return null;
  }
  return <TabContentLayout fullscreen={fullscreen}>{children}</TabContentLayout>;
};
